import { useOutreachStats } from "../hooks/useOutreachStats";
import { Skeleton } from "../../../components/ui/skeleton";

export function OutreachMetrics() {
  const { data: stats, isLoading } = useOutreachStats();

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Skeleton className="h-[100px] w-full" />
        <Skeleton className="h-[100px] w-full" />
        <Skeleton className="h-[100px] w-full" />
        <Skeleton className="h-[100px] w-full" />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <div className="p-4 rounded-lg border bg-card text-card-foreground shadow-sm">
        <h3 className="text-sm font-medium text-muted-foreground">Active Programs</h3>
        <p className="text-2xl font-bold">{stats?.activePrograms}</p>
      </div>
      <div className="p-4 rounded-lg border bg-card text-card-foreground shadow-sm">
        <h3 className="text-sm font-medium text-muted-foreground">Total Participants</h3>
        <p className="text-2xl font-bold">{stats?.totalParticipants}</p>
      </div>
      <div className="p-4 rounded-lg border bg-card text-card-foreground shadow-sm">
        <h3 className="text-sm font-medium text-muted-foreground">Locations</h3>
        <p className="text-2xl font-bold">{stats?.locations}</p>
      </div>
      <div className="p-4 rounded-lg border bg-card text-card-foreground shadow-sm">
        <h3 className="text-sm font-medium text-muted-foreground">Success Rate</h3>
        <p className="text-2xl font-bold">{stats?.successRate}%</p>
      </div>
    </div>
  );
}
